export const CREATE_NOTE = "CREATE_NOTE";
export const FETCH_NOTES = "FETCH_NOTES";
export const FETCH_NOTE = "FETCH_NOTE";
export const EDIT_NOTE = "EDIT_NOTE";
export const READ_NOTE = "READ_NOTE";
export const DELETE_NOTE = "DELETE_NOTE";
